import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables';

export const GetNpsFeedbackByMonth = async (month) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `MHL_Reports/GetNpsFeedbackByMonth?month=${month}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}